import React from 'react'
import { Outlet } from 'react-router-dom'

const AdminLayout = () => {
  return (
    <>
      <Outlet/>
    </>
  )
}

export default AdminLayout
